import React from 'react'

import Box from 'components/Box'
import Icon from 'components/Icon'
import Text from 'components/Text'

import { SocketEvents } from 'socket'
import { Notification } from 'types/global'
import { ThemeColor } from 'utils/colors'

import { IconWrapper, SalesPipeLineIcon } from './styles'

const ICON_CONFIG: { [key in SocketEvents]?: { icon: JSX.Element; iconColor?: ThemeColor } | undefined } = {
  LEAD_NAME_UPDATE: { icon: <Icon color="blue8" icon={['fal', 'pencil']} fontSize={14} /> },
  LEAD_OWNER_UPDATE: { icon: <Icon color="blue8" icon={['fal', 'pencil']} fontSize={14} /> },
  LEAD_PROCESS_UPDATE: { icon: <SalesPipeLineIcon /> },
  LEAD_STATUS_UPDATE: { icon: <SalesPipeLineIcon /> },
  WORKFLOW_PROCESS_STAGE_ADD: { icon: <SalesPipeLineIcon /> },
  WORKFLOW_PROCESS_STAGE_DELETE: { icon: <SalesPipeLineIcon />, iconColor: 'red3' },
  QUOTATION_STATUS_UPDATE: { icon: <Icon color="blue8" icon={['fal', 'file-lines']} fontSize={14} /> },
}

type Props = {
  isRead: Notification['isRead']
  notificationType: SocketEvents
  title: string
}

const NotificationHeader: React.FC<Props> = ({ isRead, notificationType, title }) => (
  <Box display="flex" alignItems="center">
    {ICON_CONFIG[notificationType]?.icon && (
      <IconWrapper background={ICON_CONFIG[notificationType]?.iconColor || 'blue8'}>
        {ICON_CONFIG[notificationType]?.icon}
      </IconWrapper>
    )}
    <Text fontWeight={isRead ? 'normal' : 'bold'} color={isRead ? 'gray5' : 'gray7'} paddingLeft="8px">
      {title}
    </Text>
  </Box>
)

export default NotificationHeader
